import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { PurchaseVerdict } from "./Analysis";

// Подписи оценок покупки: легенда таймлайна и текст для экранных дикторов.
// `Record` по union из контракта: новая оценка на бэкенде не соберётся без перевода.
export const PURCHASE_VERDICT_LABELS: Record<PurchaseVerdict, MessageDescriptor> = {
  on_time: msg({ id: "analysis.buy.verdict.on_time", message: "on time" }),
  late: msg({ id: "analysis.buy.verdict.late", message: "later than usual" }),
  very_late: msg({ id: "analysis.buy.verdict.very_late", message: "much later" }),
  situational: msg({ id: "analysis.buy.verdict.situational", message: "situational" }),
  rare: msg({ id: "analysis.buy.verdict.rare", message: "rare pick" }),
  no_baseline: msg({ id: "analysis.buy.verdict.no_baseline", message: "nothing to compare with" }),
};
